import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import { memo } from 'react';

export const RemediationDetailsSkeleton = memo(() => {
  const blocks = [
    { label: 'remediation', skeletons: 4 },
    { label: 'triage', skeletons: 1 },
    { label: 'specificRemediationAdvice', skeletons: 2 },
    { label: 'reference', skeletons: 1 },
    { label: 'specificRemediation', skeletons: 2 },
  ] as const;

  return (
    <Stack spacing={3}>
      {blocks.map((b) => {
        const array = Array.from(Array(b.skeletons).keys());
        return (
          <Box key={b.label}>
            <Typography fontWeight={500} gutterBottom>
              <Skeleton sx={{ color: 'transparent' }}>{t(b.label)}</Skeleton>
            </Typography>
            <Typography>
              {array.map((_, index) => (
                <Skeleton key={index} width="100%" />
              ))}
            </Typography>
          </Box>
        );
      })}
    </Stack>
  );
});
